import React, {Component} from 'react';
import './FancyLink.css';
import {Link} from 'react-router-dom';

class FancyLink extends Component {
	render() {
		return this.props.to ? (
			<Link
				to={this.props.to}
				className={`FancyLink ${this.props.className || ''}`}
				title={this.props.title}>
				{this.props.children}
			</Link>
		) : (
			<a
				href={this.props.href}
				target={this.props.target || '_blank'}
				rel={this.props.rel || 'noopener noreferrer'}
				className={`FancyLink ${this.props.className || ''}`}
				onClick={this.props.onClick}
				title={this.props.title}>
				{this.props.children}
			</a>
		);
	}
}

export default FancyLink;



// WEBPACK FOOTER //
// ./src/widgets/FancyLink.js